import { render, staticRenderFns } from "./carritoPopUp.vue?vue&type=template&id=1bb048f2&scoped=true"
import script from "./carritoPopUp.vue?vue&type=script&lang=js"
export * from "./carritoPopUp.vue?vue&type=script&lang=js"
import style0 from "./carritoPopUp.vue?vue&type=style&index=0&id=1bb048f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb048f2",
  null
  
)

export default component.exports